import React, { useState } from "react";
import { InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface AlertCardProps {
  text: string;
}

export default function AlertCard({ text }: AlertCardProps) {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      className="flex items-start justify-between bg-indigo-50 border border-indigo-200 text-indigo-800 rounded-md px-4 py-3 shadow-sm transition-all duration-200"
    >
      <div className="flex items-start gap-3">
        <InformationCircleIcon className="w-5 h-5 mt-[2px] flex-shrink-0 text-indigo-500" />
        <p className="text-sm leading-relaxed">{text}</p>
      </div>

      <button
        onClick={() => setVisible(false)}
        className="ml-3 text-indigo-400 hover:text-indigo-600 transition"
        aria-label="Dismiss alert"
      >
        <XMarkIcon className="w-5 h-5" />
      </button>
    </div>
  );
}
